import { insertStepsIntoThread, projectMutableStepsToTraceSteps, withThreadStepsAtIndex, withUpdatedWorkflowSteps, } from './macroStepHelpers.js';
import { buildBranchContinuationPathRelocations, nullMacroStepContext, stampAndAppendTracePoint, toTopLevelStepPath, } from './tracePointHelpers.js';
export function prepareBranchContinuation(state, context, nodeName) {
    const { step, resolvedCases } = context.stepResolution;
    const activeCase = resolvedCases[0];
    if (!activeCase) {
        throw new Error(`[${nodeName}] BranchStep ${step.stepKey} has no cases`);
    }
    return {
        context,
        activeCase,
        remainderCases: step.cases.length > 1 ? step.cases.slice(1) : [],
        rootBranchStepKey: state.rootBranchStepKeyByRemainderBranchStepKey?.[step.stepKey] ?? step.stepKey,
    };
}
export function applyBranchContinuation(state, plan, remainder) {
    const { currentThreadIndex, currentStepCounter, threadSteps } = plan.context.cursorContext;
    const branchStepKey = plan.context.stepResolution.step.stepKey;
    const { whenToolStep, whatToolStep, caseIndex } = plan.activeCase;
    const injectedSteps = remainder
        ? [whenToolStep, whatToolStep, remainder] : [whenToolStep, whatToolStep];
    const updatedWorkflow = withUpdatedWorkflowSteps(state.mutableWorkflow, withThreadStepsAtIndex(state.mutableWorkflow.stepsByThreadIndex, currentThreadIndex, insertStepsIntoThread(threadSteps, currentStepCounter, injectedSteps)));
    const event = {
        tracePointKind: 'tick',
        workflowHandle: state.mutableWorkflow.handle,
        threadIndex: currentThreadIndex,
        counterSnapshot: { stepCounterAfter: currentStepCounter + 1 },
        stepPath: toTopLevelStepPath(currentThreadIndex, currentStepCounter),
        stepKind: 'branch',
        tickKind: 'branch_continuation',
        macroStepContext: nullMacroStepContext(),
        delta: {
            stepsMutation: {
                insertAt: currentStepCounter + 1,
                insertedSteps: projectMutableStepsToTraceSteps(injectedSteps),
            },
            pathRelocations: buildBranchContinuationPathRelocations(currentThreadIndex, currentStepCounter, caseIndex),
            workflowStateDelta: {},
        },
    };
    return {
        mutableWorkflow: updatedWorkflow,
        stepCounters: { [currentThreadIndex]: currentStepCounter + 1 },
        currentThreadIndex,
        rootBranchStepKeyByRemainderBranchStepKey: {
            ...(state.rootBranchStepKeyByRemainderBranchStepKey ?? {}),
            [branchStepKey]: plan.rootBranchStepKey,
            ...(remainder ? { [remainder.stepKey]: plan.rootBranchStepKey } : {}),
        },
        ...stampAndAppendTracePoint(state, currentThreadIndex, event),
    };
}
